import React, { useState, useEffect } from 'react';
import { assetUrl } from './index.js';
import styles from './site-styles.js';

const Page = () => (
  <React.Fragment>
    <div
      style={{
        backgroundColor: 'white',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh'
      }}
    >
      <div
        style={{
          backgroundColor: 'lightgrey',
          height: '15rem',
          transform: 'rotate(1deg)'
        }}
      >
        <img
          key={'logo'}
          style={{ width: '10rem', margin: '5rem' }}
          src={`${assetUrl}/foxriot.png`}
          alt="foxriot"
        />
        software
      </div>
      <img
        key={'logo'}
        style={{ width: '10rem', margin: '5rem' }}
        src={`${assetUrl}/tripReport/icon.png`}
        alt="foxriot"
      />
      <div
        style={styles.downloadButton}
        onClick={() =>
          (window.location.href =
            'https://github.com/foxriot/trip-report-app/releases/latest/download/TripReport-Setup-1.0.0.exe')
        }
      >
        <div style={{ margin: 'auto' }}>TripReport Beta for Windows</div>
      </div>
      https://github.com/foxriot/trip-report-app/
    </div>
  </React.Fragment>
);
export default Page;
